import { target } from '../api/PushSendAPI';

/**
 * 地点情報(都道府県)
 */
export type Municipality = {
  region_code: Number;
  prefecture_code: Number;
  prefecture_name: string;
  cities: City[];
};

/**
 * 市区町村
 */
export type City = {
  city_code: Number;
  city_name: string;
  villages: Village[];
};

/**
 * 村域以下
 */
export type Village = {
  village_code: Number;
  village_name: string;
};

/**
 * 地点コード
 */
export type MunicipalityCode = {
  region_code: Number;
  prefecture_code: Number;
  city_code: Number;
  village_code: Number;
};

/**
 * 地点コード(市区町村域)
 */
export type villageCode = {
  city_code: Number;
  village_code: Number;
};

/**
 * 都道府県コードまでを削除して選択された地域のコードを返す
 * @param list
 */
export const removeMunicipalityCodeZero = (list: MunicipalityCode[]) => {
  const result: target[] = [];
  list.forEach((item: MunicipalityCode) => {
    // 都道府県(city_codeが0)
    if (item.city_code !== 0) {
      // 市区町村(village_codeが0)
      if (item.village_code === 0) {
        result.push({
          city_code: item.city_code,
          village_code: undefined,
        });
      }
      // 上位の市区町村の選択がない
      // 村域以下(上位の都道府県の選択がない)
      else if (
        !list.some(
          (v) => v.city_code === item.city_code && v.village_code === 0
        )
      ) {
        result.push({
          city_code: item.city_code,
          village_code: item.village_code,
        });
      }
    }
  });
  return result;
};

/**
 * 都道府県コードを追加する
 * @param list
 */
export const addMunicipalityCode = (list: target[]) => {
  const result: MunicipalityCode[] = [];
  list.forEach((item: target) => {
    // 都道府県(city_codeが0)
    if (item.city_code !== 0) {
      // 市区町村(village_codeが0)
      if (item.village_code === undefined) {
        result.push({
          region_code: 10,
          prefecture_code: 1,
          city_code: item.city_code,
          village_code: 0,
        });
      }
      // 上位の市区町村の選択がない
      // 村域以下(上位の都道府県の選択がない)
      else if (
        !list.some(
          (v) => v.city_code === item.city_code && v.village_code === 0
        )
      ) {
        result.push({
          region_code: 10,
          prefecture_code: 1,
          city_code: item.city_code,
          village_code: item.village_code,
        });
      }
    }
  });
  return result;
};

/**
 * sessionStorageから初期チェック市町村を求めて返す
 */
export const defaultChehckedCity = (): MunicipalityCode[] => {
  const result: MunicipalityCode[] = [];
  switch (sessionStorage.getItem('city')) {
    case '0':
      break;
    case '1':
    case '2':
      for (let index = 0; index < 7; index += 1) {
        result.push({
          region_code: 10,
          prefecture_code: 1,
          city_code: Number(sessionStorage.getItem('city')),
          village_code: index + 1,
        });
      }
      break;
    default:
      result.push({
        region_code: 10,
        prefecture_code: 1,
        city_code: Number(sessionStorage.getItem('city')),
        village_code: Number(sessionStorage.getItem('village')),
      });
      break;
  }
  return result;
};
